<div class="modal no-overflow" [ngClass]="state.visible ? 'show' : ''">
  <div class="modal__layer" (click)="onBack()"></div>
  <div class="modal__box modal__box--small" [ngClass]="state.visible ? 'show' : ''">
    <div class="modal__box__head">
      {{state.title}}
      <span class="modal__close hover-hand" (click)="onBack()"></span>
    </div>
    <div class="modal__box__body max-height">
      <p *ngFor="let text of splitBreakLines(state.text)" style="margin-top: 0; margin-bottom: 0;">
        {{text}}
        <ng-container *ngIf="text === ''">
          &nbsp;
        </ng-container>
      </p>
      <p style="margin-top: 0; margin-bottom: 0;">
        {{state.text2}}
      </p>
      <p class="text3">
        {{state.text3}}
      </p>
    </div>
    <div class="modal__box__footer">
      <div class="row">
        <div class="col-md-12 buttonLinkContainer">
          <div class="textBackButtonContainer" *ngIf="!state.noShowButtonBack" >
          <a class="btn btn--link modal__close " #buttonBack (click)="onBack()">Volver</a>
           </div>
           <div class="textBackButtonContainer"  [ngClass]="state.noShowButtonBack ? 'whitoutButtonBack' : '' "  >
          <a type="button" class="btn btn--primary width100" (click)="onAccept()">{{state.acceptButtonText}}</a>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>
